module.exports = __webpack_public_path__ + "static/media/about.3b984b4c.png";